<template>
  <v-menu
    v-model="menu"
    offset-x
    min-width="500px"
    close-on-click
    :close-on-content-click="false"
  >
    <template v-slot:activator="{ on }">
      <v-btn
        class="primary-button"
        :loading="loading"
        @click="$emit('add')"
        v-on="on"
      >
        Синхронізувати
      </v-btn>
    </template>
    <v-card>
      <v-card-text>
        <v-col>
          <DatePicker
            v-model="startDate"
            label="Дата початку синхронізації"
            :filled="false"
          />
        </v-col>
      </v-card-text>

      <v-card-actions>
        <v-spacer />
        <v-btn
          color="primary"
          text
          :disabled="!startDate"
          @click="ok()"
        >
          OK
        </v-btn>
        <v-btn
          text
          @click="cancel"
        >
          Отмена
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-menu>
</template>

<script>
import DatePicker from "@/components/story/DatePicker";

export default {
  components: {
    DatePicker,
  },
  props: {
    loading: {
      type: Boolean,
      default: false,
    },
  },
  data: () => ({
    menu: false,
    startDate: null,
    year: null,
    month: null,
  }),
  watch: {
    startDate: {
      handler(val) {
        if (val === null){
          this.year = this.moment().get("year");
          this.month = this.moment().get("month");
          this.startDate = this.moment().set({ "year": this.year, "month": this.month, "date": 1 }).format("YYYY-MM-DD");
        }
      },
      immediate: true,
    },
  },
  methods: {
    ok() {
      this.$emit("update:start", this.startDate);
      this.$emit("change");
      this.cancel();
    },
    cancel() {
      this.menu = false;
    },
  },
};
</script>
